const Inventory = () => {
  return <>Inventories Page</>;
};

export default Inventory;
